import P5 from "p5";

export class Bird {
	constructor (p5: P5) {
		this.p5 = p5;
	}
	p5: P5;
	width: number = 25;
	height: number = 30;
	x: number = 100;
	y: number = 300;
	speedx: number = 0;
	speedy: number = 0;
	flapstrength: number = 6;

	flap() {
		console.log('flappy');
		this.speedy = -this.flapstrength;
	}

	show() {
		this.p5.fill(200,200,0);
		this.p5.rect(this.x,this.y,this.width,this.height);
		this.p5.fill(51);
		this.p5.rect(this.x+this.width*3/5,this.y+this.height/3,this.width*2/3,this.height/3);
	}

	update() {
		this.speedy = this.speedy + 0.3;
		this.x = this.x + this.speedx;
		this.y = this.y + this.speedy;
	}
}
